import { render, staticRenderFns } from "./AlertColor.vue?vue&type=template&id=07d5e76d&"
import script from "./AlertColor.vue?vue&type=script&lang=js&"
export * from "./AlertColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports